<template>
  <DUserLinkPopup
    :user-id="activity.user.id"
    :should-display-popup="!activity.is_owner"
  >
    <template slot="content">
      <img
        :alt="getUserName()"
        class="d-activity-avatar"
        :src="activity.user.avatar_url"
      >
    </template>
  </DUserLinkPopup>
</template>

<script>
import DUserLinkPopup from '@d-components/d-user-link-popup/d-user-link-popup.vue';

export default {
  components: {
    DUserLinkPopup,
  },
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getUserName() {
      return `${ this.activity.user.firstname } ${ this.activity.user.lastname }`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-activity-avatar {
  border-radius: 50%;
  height: $_4em;
  margin-right: $_1em;
  width: $_4em;
}
</style>
